import React from "react";
import { useSelector } from "react-redux";
import useTheme from "../../hooks/useTheme";
import { useTranslation } from "react-i18next";

export default function OrderPrice({ orderType }) {
  const { t } = useTranslation();
  const order = useSelector((state) => state.cart.cart);
  const { profile } = useSelector((state) => state.profile);
  const theme = useTheme();

  // Helper function to format price - remove .00 if decimal part is 00
  const formatPrice = (price) => {
    const numericPrice = typeof price === 'string' ? parseFloat(price) : price;
    const formattedPrice = numericPrice.toFixed(2);
    return formattedPrice.replace('.00', '');
  };
  
  let subtotal = 0;
  let currency = profile?.currency || "AED";
  
  for (var i = 0; i < order.length; i++) {
    subtotal += order[i].price * order[i].quantity;
  }

  const deliveryCharge = profile?.delivery_charge !== null && profile?.delivery_charge !== undefined 
    ? parseFloat(profile.delivery_charge) 
    : null;
  const showDeliveryRow = orderType === 'delivery' && deliveryCharge !== null;
  
  const total = subtotal + (orderType === 'delivery' && deliveryCharge !== null && deliveryCharge > 0 ? deliveryCharge : 0);
  
  return (
    <div className="bg-gradient-to-r from-gray-50 to-gray-100 rounded-lg md:rounded-xl p-3 md:p-4 lg:p-6 border border-gray-200">
      <h3 className="text-sm md:text-base lg:text-lg font-semibold text-gray-800 mb-2 md:mb-3 lg:mb-4 poppins">{t('order_summary.title')}</h3>
      
      <div className="space-y-1.5 md:space-y-2 lg:space-y-3">
        {/* Subtotal */}
        <div className="flex items-center justify-between">
          <span className="text-sm md:text-base text-gray-700 poppins" style={{ lineHeight: '1.8' }}>{t('order_summary.subtotal')}</span>
          <span className={`text-sm md:text-base text-gray-700 poppins ${currency === 'AED' ? 'currency-aed' : ''}`} style={{ lineHeight: '1.8' }}>
            {currency} {formatPrice(subtotal)}
          </span>
        </div>
        
        {/* Delivery Charge - Show for delivery orders */}
        {showDeliveryRow && (
          <div className="flex items-center justify-between">
            <span className="text-sm md:text-base text-gray-700 poppins" style={{ lineHeight: '1.8' }}>{t('order_summary.delivery_charge')}</span>
            {deliveryCharge > 0 ? (
              <span className={`text-sm md:text-base text-gray-700 poppins ${currency === 'AED' ? 'currency-aed' : ''}`} style={{ lineHeight: '1.8' }}>
                {currency} {formatPrice(deliveryCharge)}
              </span>
            ) : deliveryCharge === 0 ? (
              <span className="text-sm md:text-base font-semibold text-green-600 poppins" style={{ lineHeight: '1.8' }}>
                {t('order_summary.free_delivery')}
              </span>
            ) : (
              <span className="text-sm md:text-base text-gray-700 poppins" style={{ lineHeight: '1.8' }}>
                {t('order_summary.applicable')}
              </span>
            )}
          </div>
        )}
        
        {/* Total */}
        <div className="border-t border-gray-300 pt-1.5 md:pt-2 lg:pt-3 mt-1.5 md:mt-2 lg:pt-3">
          <div className="flex items-center justify-between">
            <span className="text-base md:text-lg lg:text-xl font-bold text-gray-800 poppins" style={{ lineHeight: '1.8' }}>{t('order_summary.total')}</span>
            <span 
              className={`text-base md:text-lg lg:text-xl font-bold poppins ${currency === 'AED' ? 'currency-aed' : ''}`}
              style={{ color: theme.colors.cartTotalAmountColor, lineHeight: '1.8' }}
            >
              {currency} {formatPrice(total)}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}
